import React, { useEffect, useState } from 'react';
import './TariffModal.css';
import Modal from './common/Modal';
import { ServiceTypeOptions, ServiceTypeNames } from '../constants/serviceTypes';

const TariffModal = ({ isOpen, onClose, onSave, tariff = null }) => {
  const isEdit = !!tariff;
  const [form, setForm] = useState({
    name: '',
    type: ServiceTypeOptions[0].value,
    value: '',
    coefficient: 1,
  });

  useEffect(() => {
    if (isOpen) {
      if (isEdit) {
        setForm({
          name: tariff.name || ServiceTypeNames[tariff.type] || '',
          type: tariff.type,
          value: tariff.value,
          coefficient: tariff.coefficient ?? 1,
        });
      } else {
        const defaultType = ServiceTypeOptions[0].value;
        setForm({
          name: ServiceTypeNames[defaultType],
          type: defaultType,
          value: '',
          coefficient: 1,
        });
      }
    }
  }, [isOpen, isEdit, tariff]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleTypeChange = (e) => {
    const typeValue = parseInt(e.target.value);
    setForm((prev) => ({
      ...prev,
      type: typeValue,
      name: ServiceTypeNames[typeValue],
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      name: form.name,
      type: parseInt(form.type),
      value: parseFloat(form.value),
      coefficient: parseFloat(form.coefficient) || 1,
    };
    onSave(payload, tariff);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      overlayClassName="modal-overlay"
      contentClassName="modal-content"
    >
      <div className="modal-header">
        <h2>{isEdit ? 'Редактировать тариф' : 'Добавить тариф'}</h2>
        <button className="close-button" onClick={onClose}>
          ×
        </button>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="type">Тип тарифа *</label>
          <select
            id="type"
            name="type"
            value={form.type}
            onChange={handleTypeChange}
            required
            disabled={isEdit}
          >
            {ServiceTypeOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="name">Название *</label>
          <input
            id="name"
            name="name"
            type="text"
            value={form.name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="value">Стоимость *</label>
          <input
            id="value"
            name="value"
            type="number"
            step="0.01"
            value={form.value}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="coefficient">Коэффициент</label>
          <input
            id="coefficient"
            name="coefficient"
            type="number"
            step="0.01"
            value={form.coefficient}
            onChange={handleChange}
          />
        </div>
        <div className="modal-actions">
          <button type="button" className="button-secondary" onClick={onClose}>
            Отмена
          </button>
          <button type="submit" className="button-primary">
            {isEdit ? 'Сохранить' : 'Добавить'}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default TariffModal;
